<template>
    <tbody v-if="post_types">
        <tr>
            <td colspan="2"><h2>Post Types</h2></td>
        </tr>
        <tr v-for="post_type in post_types">
            <td :data-export-label="post_type.type">{{ post_type.type }}: </td>

            <td> {{ post_type.count }} </td>
        </tr>
    </tbody>
</template>
<script>
export default {
    name: 'PostTypes',

    props: ['post_types']
};
</script>
